import config from '../config';
import { request } from '../utils/request';
const gitlabDomain = `${config.host}${config.apiRouter.gitlab}`;
const projectId = encodeURIComponent('MiniPrograms/docs').replace(/%2F/g, '^2F');
// const projectId = 748;
const api = {
  /**
   * list all projects
   * @param {*} data
   */
  listProjects () {
    return request.get(`${gitlabDomain}/api/projects`);
  },
  /**
   * create a commit by posting a JSON payload
   * @param data
   * @param projectName
   * @returns {*}
   */
  commit (data, projectName = projectId) {
    return request.post(`${gitlabDomain}/api/projects/${projectName}/repository/commits`, data);
  },
  /**
   * 根据文件路径获取文件
   * @param {*} param0
   */
  getFileFromRepository ({ filePath, ref }) {
    return request.get(`${gitlabDomain}/api/projects/${projectId}/repository/files/${encodeURIComponent(filePath).replace(/%2F/g, '^2F')}?ref=${ref}`);
  },
  publish () {
    return request.get(`${gitlabDomain}/Publish`);
  },
};
export default api;
